var styles = {"fontElementMap":"reyXt","orderedlist":"QmsvW","bulletedlist":"atc3U","listItem":"Aj3k2"};

export { styles as s };
//# sourceMappingURL=lists-f04d6352.js.map
